<template>
  <layout>
    <div id="show-company">
      <!-- Header -->
      <header
        :class="`${headerClasses()}`"
        :style="{
          'background-image': `url(${getHeaderImage})`,
          'background-color': `${getPrimaryColor}`
        }"
      >
        <!-- filter-header -->
        <div
          :class="`${currentScopedCompany.id == 2728 ? '' : 'overlay opacity-35'}`"
          style="background-image: linear-gradient(to top, #000000 0%, #000000 100%);"
        />
        <div class="container text-center index-up">
          <div class="row">
            <div class="col-md-8 mx-auto pt-12 pb-9" />
          </div>

          <div class="partner partner-sm">
            <search-bar :class="`${searchBarClasses()}`" />
          </div>
        </div>
      </header><!-- /.header -->

      <!-- Main Content -->
      <main class="main-content">
        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | List Vacancy
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <section class="section pt-10 pb-6">
          <h1
            class="display-41 animated fadeInDown delay-1s slow text-center mb-6"
            :style="{'color': `${getSecondaryColor}`}"
          >
            Oportunidades disponíveis
          </h1>
          <list-vacancy />
        </section>

        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | Call to action
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->

        <section
          class="section py-7 mt-3 mb-6 section-to-action"
          :style="{'background-image': `url(${require('../assets/landings/bg/bg-img-calltoaction.png')})`, 'background-color': `#ffffff`}"
        >
          <div
            class="overlay opacity-100"
            :style="{'background-color': `${getSecondaryColor}`}"
          />
          <div class="container">
            <div class="row gap-y align-items-center">
              <div class="col-md-9">
                <h5 class="mb-0 text-white text-center text-md-left">
                  Não encontrou o emprego dos seus sonhos? Cadastre seu currículo e receba notificações das melhores vagas para o seu perfil!
                </h5>
              </div>

              <div class="col-md-3 text-center text-md-right">
                <a
                  class="btn btn-lg btn-round btn-light"
                  :href="getSignUpUrl(getCurrentScopedCompanySubdomain)"
                  :style="{'color': `${getSecondaryColor}`}"
                >
                  ME CADASTRAR
                </a>
              </div>
            </div>
          </div>
        </section>

        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | About Company
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <div v-if="getCurrentScopedCompanyPage.manifest">
          <section
            id="about-company"
            class="section pt-5 pb-8"
          >
            <div class="container">
              <div class="row gap-y align-items-center">
                <div class="col-lg-12">
                  <h2 class="text-color-fifth">
                    Sobre a empresa
                  </h2>
                  <div
                    class="manifest-text text-justify"
                    v-html="getCurrentScopedCompanyPage.manifest"
                  />
                </div>
                <div
                  v-if="currentScopedCompanyHasVideo || currentScopedCompanyHasImages"
                  class="col-lg-12"
                >
                  <div class="gallery gallery-4-type4">
                    <!-- First image company -->
                    <a
                      v-if="!currentScopedCompanyHasVideo"
                      class="gallery-item"
                      href="#"
                    >
                      <img
                        v-img:group
                        :src="currentScopedCompanyConfigImage[0].file.url"
                        alt="..."
                      >
                    </a>
                    <!-- Vídeo company -->
                    <div
                      v-if="currentScopedCompanyHasVideo && !videoUrlError"
                      class="video-btn-wrapper gallery-item"
                      :style="singleVideo"
                    >
                      <img
                        class="shadow-4 rounded-lg"
                        :src="getThumbVideo(getCurrentScopedCompanyPage.video_url)"
                        alt="watch a video"
                      >
                      <a
                        class="btn btn-circle btn-xl btn-info"
                        :href="getCurrentScopedCompanyPage.video_url"
                        data-provide="lightbox"
                      >
                        <i class="fa fa-play" />
                      </a>
                    </div>

                    <div class="gallery-item-group">
                      <!-- Galeria de imagens -->
                      <template v-if="currentScopedCompanyHasVideo">
                        <a
                          v-for="(photo, index) in currentScopedCompanyConfigImage"
                          :key="index"
                          v-if="index < 4"
                          class="gallery-item"
                          href="#"
                        >
                          <img
                            v-img:group
                            :src="photo.file.url"
                            alt="..."
                          >
                        </a>
                      </template>
                      <template v-else>
                        <a
                          v-for="(photo, index) in currentScopedCompanyConfigImage"
                          :key="index"
                          v-if="index >= 1"
                          class="gallery-item"
                          href="#"
                        >
                          <img
                            v-img:group
                            :src="photo.file.url"
                            alt="..."
                          >
                        </a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main><!-- /.main-content -->
    </div>
  </layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Axios from 'axios';
import Layout from './shared/layout.vue';
import SearchBar from '../components/search-bar.vue';
import ListVacancy from '../components/list-vacancy.vue';
import mixins from '../mixins/mixins';

export default {
  name: 'ShowCompany',
  components: {
    Layout,
    SearchBar,
    ListVacancy,
  },
  mixins: [mixins],
  props: {
    currentUserProp: {
      type: Object,
      required: true,
    },
    currentUserTypeProp: {
      type: String,
      required: true,
    },
    scopedCompanyProp: {
      type: Object,
      required: true,
    },
    scopedCompanyPageProp: {
      type: Object,
      required: true,
    },
    scopedCompanySubdomainProp: {
      type: Object,
      required: true,
    },
    scopedCompanyConfigImageProp: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      textButton: '',
      currentdomain: '',
      separate: window.location.host.split('.'),
      companyBrand: '',
      videoThumbnail: '',
      videoUrlError: false,
    };
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompany',
      'currentScopedCompanyConfigImage',
      'currentScopedCompanyPage',
      'currentScopedCompanySubdomain',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'userIsLoggedIn',
    ]),
    ...mapGetters('CompanyStore', [
      'currentScopedCompanyManagerOther',
      'currentScopedCompanyHasImages',
      'currentScopedCompanyHasVideo',
      'getHeaderImage',
      'getPrimaryColor',
      'getSecondaryColor',
      'getCurrentScopedCompanySubdomain',
      'getCurrentScopedCompanyPage',
    ]),
    singleVideo() {
      return {
        flexBasis: !this.currentScopedCompanyHasImages ? '100%' : '50%',
      };
    },
  },
  async mounted() {
    const currentUser = { ...this.currentUserProp };
    const currentUserType = this.currentUserTypeProp;
    const scopedCompany = { ...this.scopedCompanyProp };
    const scopedCompanyPage = { ...this.scopedCompanyPageProp };
    const scopedCompanySubdomain = { ...this.scopedCompanySubdomainProp };
    const scopedCompanyConfigImage = { ...this.scopedCompanyConfigImageProp };

    await this.$store.commit('UserStore/SET_CURRENT_USER', currentUser);
    await this.$store.commit('UserStore/SET_CURRENT_USER_TYPE', currentUserType);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY', scopedCompany);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY_PAGE', scopedCompanyPage);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY_SUBDOMAIN', scopedCompanySubdomain);
    await this.$store.commit('CompanyStore/SET_CURRENT_SCOPED_COMPANY_CONFIG_IMAGE', scopedCompanyConfigImage);

    // ==========================
    // Actions remove subdomain
    // ==========================
    this.separate.shift();
    this.currentdomain = this.separate.join('.');
  },
  methods: {
    getThumbVideo(url) {
      if (_.includes(url, 'youtube')) {
        const youtubeVideo = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)
        let youtubeVideoId = '';

        if (youtubeVideo) {
          youtubeVideoId = youtubeVideo.pop();
        } else {
          this.videoUrlError = true;
        }

        if (youtubeVideoId.length === 11) {
          this.videoThumbnail = `https://img.youtube.com/vi/${youtubeVideoId}/sddefault.jpg`;
        }
      } else if (_.includes(url, 'youtu.be')) {
        const youtubeVideoId = url.match(/youtu\.be.*()(.{11})/).pop();

        if (youtubeVideoId.length === 11) {
          this.videoThumbnail = `https://img.youtube.com/vi/${youtubeVideoId}/sddefault.jpg`;
        }
      } else if (_.includes(url, 'vimeo')) {
        const vimeoVideoId = url.match(/vimeo\.com.*()(.{9})/).pop();

        if (vimeoVideoId.length === 9) {
          Axios.defaults.headers.common = [];
          Axios.get(`https://vimeo.com/api/v2/video/${vimeoVideoId}.json`)
            .then((response) => {
              this.videoThumbnail = response.data[0].thumbnail_large;
            })
            .catch(() => {});
        }
      } else {
        this.videoUrlError = true;
      }

      return this.videoThumbnail;
    },
    getSignUpUrl(currentScopedCompanySubdomain) {
      let url = `${this.protocol}candidatos.${this.currentdomain}/sign-up`;
      if (currentScopedCompanySubdomain.subdomain) {
        url += `?subdomain=${currentScopedCompanySubdomain.subdomain}`;
      }
      return url;
    },

    headerClasses() {
      // CETEFE RH 3820
      if (this.currentScopedCompany.id === 3820) {
        return 'header text-white py-2 cetefe-header';
      }

      return 'header text-white py-2';
    },

    searchBarClasses() {
      // CETEFE RH 3820
      if (this.currentScopedCompany.id === 3820) {
        return 'animated fadeInUp delay-1s slow cetefe-search-bar';
      }

      return 'animated fadeInUp delay-1s slow';
    },
  },
};
</script>

<style lang="scss" scoped>
  #show-company {
    .cetefe-header {
      height: 720px;
      background-size: 100% 720px;
      background-position: 0 0;

      @media screen and (max-width: 576px) {
        height: auto;
        background-size: 100% auto;
      }
    }

    header.header {
      #search-bar {
        position: absolute;
        bottom: -25%;

        @media screen and (max-width: 576px) {
          bottom: -38%;
        }
      }

      #search-bar.cetefe-search-bar {
        position: absolute;
        bottom: -10%;

        @media screen and (max-width: 576px) {
          bottom: -38%;
        }
      }
    }

    .gallery-4-type4 > .gallery-item {
      flex-basis: 50%;
      max-height: 404px;
    }

    .gallery-4-type4 .gallery-item-group {
      flex-basis: 50%;
      display: flex;
      flex-wrap: wrap;
    }

    .gallery-item-group {
      .gallery-item {
        max-height: 202px;
      }
    }

    .section-to-action {
      background-size: auto 100%;
      background-position: left center;

      .btn {
        color: rgb(1, 158, 146);
      }
    }

    .overlay {
      background-color: rgb(1, 158, 146);
      mix-blend-mode: multiply;
    }

    #about-company .manifest-text {
      p {
        margin: 0 !important;
      }
    }
  }

  .index-up {
    z-index: 1 !important;
  }
</style>
